module.exports = __webpack_public_path__ + "media/img/team-members/team-photo-aaee152cff10ffa302e7cc378983a2b5.jpg";